import * as React from "react";
import { Button, Input, Modal, Toast } from "react-ui";

import { RequisitesInfo } from "../../../../Engine/Form/IForm";
import { setFakeRequisitesForDraft } from "../../../../Engine/Fakes/FakeRequisites";
import { DraftFullId } from "../../../../../../Common/CandyApiClient/Types/DraftFullId";
import { Icon } from "../../../Icons/Icon";

import {
    Body,
    Caption,
    Notes,
    RequisitesForm,
    RequisitesFormLine,
    Title,
    Value,
    Warning,
} from "./SetFakeRequisitesModal.styles";

interface SetFakeRequisitesModalProps {
    requisiteList: string[];
    requisitesInfo: RequisitesInfo;
    draftId: DraftFullId;
    onClose: () => void;
}

export function SetFakeRequisitesModal(props: SetFakeRequisitesModalProps): JSX.Element {
    const [currentRequisitesInfo, setCurrentRequisitesInfo] = React.useState(props.requisitesInfo);
    const requisiteNames = React.useMemo(
        () => props.requisiteList.map(x => x.replace(/\.value$/, "")),
        [props.requisiteList]
    );

    const handleSetRequisitesInfo = () => {
        setFakeRequisitesForDraft(props.draftId, currentRequisitesInfo);
        Toast.push("Реквизиты установлены.", {
            label: "Перезагрузить страницу",
            handler: () => {
                window.location.reload();
            },
        });
        props.onClose();
    };

    return (
        <Modal onClose={props.onClose}>
            <Modal.Header>Установить фейковые реквизиты</Modal.Header>
            <Modal.Body>
                <Body>
                    <Title>Реквизиты, используемые в форме.</Title>
                    <Notes>
                        <Warning>
                            <Icon name="WarningTriangleIcon" />
                        </Warning>{" "}
                        Фейковые реквизиты устанавливаеются в браузере и влияют только на редактор.
                    </Notes>
                    <RequisitesForm>
                        {requisiteNames.map(requisiteName => (
                            <RequisitesFormLine key={requisiteName}>
                                <Caption>{requisiteName}</Caption>
                                <Value>
                                    <Input
                                        width={400}
                                        value={currentRequisitesInfo[requisiteName]?.value ?? ""}
                                        onValueChange={nextValue => {
                                            if (nextValue !== "") {
                                                setCurrentRequisitesInfo({
                                                    ...currentRequisitesInfo,
                                                    [requisiteName]: { value: nextValue },
                                                });
                                            } else {
                                                const nextCurrentRequisitesInfo = { ...currentRequisitesInfo };
                                                delete nextCurrentRequisitesInfo[requisiteName];
                                                setCurrentRequisitesInfo(nextCurrentRequisitesInfo);
                                            }
                                        }}
                                    />
                                </Value>
                            </RequisitesFormLine>
                        ))}
                    </RequisitesForm>
                </Body>
            </Modal.Body>
            <Modal.Footer panel>
                <Button use="primary" onClick={handleSetRequisitesInfo}>
                    Установить
                </Button>{" "}
                <Button onClick={props.onClose}>Отмена</Button>
            </Modal.Footer>
        </Modal>
    );
}
